import React, { createContext, useState, useContext, useEffect } from 'react';
import { StoreContext } from './StoreContext';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const { cartData } = useContext(StoreContext);
  const [hasItems, setHasItems] = useState(false);
  const [uniqueItemsCount, setUniqueItemsCount] = useState(0);

  // Update cart status whenever cartData changes
  useEffect(() => {
    const count = Object.keys(cartData).length;
    setHasItems(count > 0);
    setUniqueItemsCount(count);
  }, [cartData]);

  return (
    <CartContext.Provider value={{ 
      hasItems, 
      uniqueItemsCount
    }}>
      {children}
    </CartContext.Provider>
  );
}; 